"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompleteLiveInfo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Layout = require("../Layout");

var _StyledElements = require("./StyledElements");

var CompleteLiveInfo = function CompleteLiveInfo(_ref) {
  var streamers = _ref.streamers,
      liveInfo = _ref.liveInfo,
      props = (0, _objectWithoutProperties2.default)(_ref, ["streamers", "liveInfo"]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Layout.Flex, {
    height: "100%",
    alignItems: "center"
  }, _react.default.createElement(_Layout.Flex, {
    minWidth: streamers.length > 1 ? '68px' : '40px',
    marginRight: 2,
    height: "100%",
    alignItems: "center",
    flexGrow: 0
  }, _react.default.createElement(_StyledElements.StreamersAvatar, {
    streamers: streamers
  })), _react.default.createElement(_Layout.Flex, {
    flexDirection: "column",
    flexGrow: 1,
    minWidth: 0
  }, _react.default.createElement(_StyledElements.HeadlineTextItem, (0, _extends2.default)({
    text: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.scheduledAt
  }, props)), _react.default.createElement(_Layout.Flex, null, _react.default.createElement(_StyledElements.HeadlineStreamerItem, (0, _extends2.default)({
    fontWeight: "medium",
    text: (0, _StyledElements.getStreamersName)({
      streamers: streamers
    })
  }, props)), _react.default.createElement(_StyledElements.ElementsDivisor, props), _react.default.createElement(_StyledElements.HeadlineTextItem, (0, _extends2.default)({
    text: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.language
  }, props))))), _react.default.createElement(_StyledElements.LiveTitle, (0, _extends2.default)({
    text: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.title
  }, props)));
};

exports.CompleteLiveInfo = CompleteLiveInfo;